import { useEffect } from "react";
import { store } from "utils/@reduxjs/store";

export const useInjectReducer = (key, reducer) => {
  useEffect(() => {
    store.injectReducer(key, reducer);
  }, [key, reducer]);
};
